<template>
    <div class="discount_vip">
        <div class="vip">
            <div class="item" v-for="(item, index) in vip" :key="index">
                <div class="cover" :style="`background-image: url(${item.image});`"></div>
                <p>{{item.text}}</p>
            </div>
        </div>
        <swiper ref="swiper" class="mobile" :options="options">
            <template v-for="(item, index) in vip">
                <swiper-slide :key="index">
                    <div class="cover" :style="`background-image: url(${item.image});`"></div>
                </swiper-slide>
            </template>
        </swiper>
    </div>
</template>

<script>
import { swiper, swiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
    name: "discountVip",
    data() {
        return {
            vip: [
                { text: '银卡会员', image: require('@/assets/images/images_vip_011.png') },
                { text: '金卡会员', image: require('@/assets/images/images_vip_012.png') },
                { text: '铂金会员', image: require('@/assets/images/images_vip_013.png') },
            ],
            options: {
                slidesPerView: 'auto',
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                // spaceBetween: '3%',
                centeredSlides: true,
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.swiper
        },
    },
    components: {
        swiper,
        swiperSlide,
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.discount_vip{
    .mobile{
        display: none;
    }
    .vip{
        display: flex;
        margin-bottom: .8rem;
        .item{
            flex: 1;
            text-align: center;
            font-weight: bold;
            .cover{
                width: 2.69rem;
                height: 1.61rem;
                background: no-repeat 0/100%;
                margin: 0 auto .2rem;
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        .vip{
            display: none;
        }
        .mobile{
            display: block;
        }
        .swiper-slide{
            width: 9.24rem;
            height: 5.53rem;
            transform-origin: 50% 100%;
            transform: scale(.8);
            transition: transform .5s;
            &.swiper-slide-active{
                transform: scale(1);
            }
            .cover{
                width: 100%;
                height: 100%;
                background: no-repeat center/cover;
            }
        }
    }
}
</style>